export const isRecipePath = (pathname: string) =>
  /^\/u\/[^/]+\/recipes?\/[^/]+$/.test(pathname) ||
  /^\/recipe\/[^/]+$/.test(pathname);

const MAX_SLUG_LENGTH = 60;

const slugify = (name: string): string =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, MAX_SLUG_LENGTH);

const MONTH_ABBRS = [
  "jan", "feb", "mar", "apr", "may", "jun",
  "jul", "aug", "sep", "oct", "nov", "dec",
];

/**
 * Build a date-range slug for a meal plan from ISO date strings.
 * e.g. "2026-06-02", "2026-06-08" → "jun-2-8"
 *      "2026-06-30", "2026-07-06" → "jun-30-jul-6"
 */
const datesToSlug = (startDate: string, endDate: string): string => {
  const s = new Date(startDate + "T00:00:00");
  const e = new Date(endDate + "T00:00:00");
  const sMonth = MONTH_ABBRS[s.getMonth()];
  const eMonth = MONTH_ABBRS[e.getMonth()];
  if (sMonth === eMonth) {
    if (s.getDate() === e.getDate()) return `${sMonth}-${s.getDate()}`;
    return `${sMonth}-${s.getDate()}-${e.getDate()}`;
  }
  return `${sMonth}-${s.getDate()}-${eMonth}-${e.getDate()}`;
};

/**
 * Build a friendly URL path for a recipe.
 * Falls back to the legacy /u/ path if shortId is not available.
 */
export const buildRecipePath = (
  recipe: { shortId?: string; name: string; id: string },
  userId: string
): string =>
  recipe.shortId
    ? `/recipe/${slugify(recipe.name) ? `${slugify(recipe.name)}-` : ''}${recipe.shortId}`
    : `/u/${userId}/recipe/${recipe.id}`;

/**
 * Build a friendly URL path for a meal plan.
 * Falls back to the legacy /u/ path if shortId is not available.
 */
export const buildPlanPath = (
  plan: { shortId?: string; id: string; startDate: string; endDate: string },
  userId: string
): string =>
  plan.shortId
    ? `/plan/${datesToSlug(plan.startDate, plan.endDate)}-${plan.shortId}`
    : `/u/${userId}/plan/${plan.id}`;
